<template>
  <div>
    <!-- 提出复审 -->
    <el-dialog :close-on-click-modal="false" :title="$t('message.requestReReview')" :visible.sync="dialogVisible"
      width="780px" center>
      <div class="content">
        <!-- 复审原因 -->
        <div class="row">
          <div class="label">
            <span>*</span> {{ $t('message.reReviewReason') }} :
          </div>
          <div class="val">
            <el-input type="textarea" v-model="datas.review_reason"
              :placeholder="$t('message.MinistersMessage')"></el-input>
          </div>
        </div>
        <!-- 补充截图： -->
        <div class="row">
          <div class="label">
            <span>*</span> {{ $t('message.supplementalScreenshots') }} :
          </div>
          <div class="val">
            <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :before-upload="befoUpload"
              :on-success="successup" :on-preview="handlePictureCardPreview" :limit="8" :on-exceed="exceed"
              :on-remove="handleRemove" list-type="picture-card" accept=".jpg,.jpeg,.png" :file-list="fileList" drag>
              <i class="el-icon-plus"></i>
            </el-upload>
            <p>1、请添加投诉处理的完整截图</p>
            <p>2、共可上传8张图片</p>
            <p>3、只支持jpeg、jpg、png格式、单张最大5M</p>
          </div>
        </div>
        <!-- *是否纳入考核 -->
        <div class="row">
          <div class="label" style="line-height: 40px;">
            <span>*</span> {{ $t('message.isIncludedInAssessment') }} :
          </div>
          <div class="val" style="line-height: 40px;">
            <!-- 是 -->
            <el-radio v-model="datas.performance_status" :label="1">{{ $t('message.are') }}</el-radio>
            <!-- 否 -->
            <el-radio v-model="datas.performance_status" :label="2">{{ $t('message.no') }}</el-radio>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">
          {{ $t("message.cancel") }}
        </el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="save">
          {{ $t("message.save") }}
        </el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="imgDialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      datas: {
        id: '',
        type: '',
        content: '',
        depart_images: [],
      },
      imgDialogVisible: false,
      dialogImageUrl: ''
    };
  },
  methods: {
    handleRemove(res, fileList) {
      this.fileList = fileList
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgDialogVisible = true;
    },
    // 图片上传成功事件
    successup(res, file, fileList) {
      this.fileList = fileList
      this.$forceUpdate()
    },
    // 最多四张
    exceed() {
      this.$alert('最多只能传8张图片', '提示', {
        confirmButtonText: '确定',
        center: true,
        callback: action => {
        }
      });
    },
    befoUpload(file) {
      const isJPG =
        ["image/jpeg", "image/png", "image/jpg"].indexOf(file.type) != -1;
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error('上传文件大小不能超过 5MB!');
      }
      if (!isJPG) {
        this.$message.error(this.$fanyi("请上传图片"));
        return isJPG && isLt5M;
      }
    },
    // 保存
    save() {
      this.datas.depart_images = []
      this.fileList.forEach(item => {
        this.datas.depart_images.push(item.response.data)
      })

      this.$api.siteConfiguration.departConfirmReviewV4(this.datas).then(res => {
        this.dialogVisible = false
        this.$parent.clientListV4()
      })
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;

  .row {
    display: flex;
    margin-bottom: 20px;

    .label {
      line-height: 118px;
      margin-right: 20px;
      width: 120px;

      span {
        color: red;
      }
    }

    .val {
      flex: 3;

      p {
        margin-top: 20px;
      }
    }
  }
}

/deep/ .el-upload-dragger {
  width: 118px;
  height: 118px;
  border: none;
}
</style>
